import React from "react";
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { auth } from "../../../_services";
import { withTranslation } from "react-i18next";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  Divider
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "./profile.css";

class Profile extends React.Component {
  _isMounted = false;
  toastObj;

  constructor(props) {
    super(props);
    const { t } = this.props;
    this.position = { X: "Right", Y: "Bottom" };
    this.state = {
      myData: undefined,
      didMountCompleted: false,
      showConfirmDialog: false,
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",
      showPwd: {
        old: false,
        new: false,
        confirm: false
      },
      toastInfo: {
        title: "",
        content: "Successfully",
        cssClass: "e-toast-success",
        icon: "e-success toast-icons",
      },
    };
    this.confirmButton = [
      {
        click: () => this.saveAndClosDialog(),
        buttonModel: { content: t("yes"), isPrimary: true },
      },
      {
        click: () => this.setState({ showConfirmDialog: false }),
        buttonModel: { content: t("no") },
      },
    ];
  }

  async componentDidMount() {
    this._isMounted = true;
    let { data: myData } = await auth.getAnaData();
    myData.userRole = auth.getUserRole();
    if (this._isMounted) {
      this.setState({ didMountCompleted: true, myData });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setToastInfo(title, errorMsg) {
    let toastInfo = { ...this.state.toastInfo };
    const map = {
      Warning: ["e-toast-warning", "e-warning"],
      Success: ["e-toast-success", "e-success"],
      Error: ["e-toast-danger", "e-error"],
      Information: ["e-toast-info", "e-info"],
    };
    if (map[title]) {
      [toastInfo.cssClass, toastInfo.icon] = map[title];
    }
    toastInfo.title = title;
    toastInfo.content = errorMsg;
    this.setState({ toastInfo }, () => this.toastObj.show());
  }

  async saveAndClosDialog() {
    let { oldPwd, newPwd } = this.state;
    await auth.AuthChangePassword(oldPwd, newPwd);
    this.setState({ showConfirmDialog: false, oldPwd: "", newPwd: "", confirmPwd: "" });
    this.setToastInfo("Success", this.props.t("toastSuccess"));
  }

  confirmSave() {
    let { myData } = this.state;
    delete myData.userRole;
    myData.email = document.getElementById("email").value;
    myData.home = document.getElementById("home").value;
    myData.mobile = document.getElementById("mobile").value;
    auth.updateProfile(myData)
      .then((res) => {
        this.setToastInfo(res.data ? "Success" : "Error", res.data ? this.props.t("toastSuccess") : "U: " + res.statusText);
      })
      .catch((err) => {
        this.setToastInfo("Error", "U: " + err.message);
      });
  }

  openDialog() {
    this.setState({ showConfirmDialog: true });
  }

  isPasswordStrong(pwd) {
    const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/;
    return strongRegex.test(pwd);
  }

  onPwdInputChange(field, value) {
    const newState = { ...this.state, [field]: value };
    const { oldPwd, newPwd, confirmPwd } = newState;
    const allFilled = oldPwd && newPwd && confirmPwd;
    const isValid =
      allFilled &&
      newPwd === confirmPwd &&
      this.isPasswordStrong(newPwd);
    newState.isPwdValid = isValid;
    this.setState(newState);
  }

  togglePasswordVisibility(field) {
    this.setState((prevState) => ({
      showPwd: {
        ...prevState.showPwd,
        [field]: !prevState.showPwd[field]
      }
    }));
  }

  render() {
    const { myData, toastInfo, showConfirmDialog, isPwdValid, oldPwd, newPwd, confirmPwd, showPwd } = this.state;
    const { t } = this.props;
    return (
      <Box sx={{ p: 2 }} id="target">
        {myData && (
          <Box>
            <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
              <Typography variant="h6" gutterBottom>{t("lblAnaUserData")}</Typography>
              <Divider sx={{ mb: 2 }} />
			  <Grid container spacing={2}>
                <Grid item xs={12} md={4}><TextBoxComponent placeholder={t("name")} disabled value={myData.name} floatLabelType="Auto" /></Grid>
                <Grid item xs={12} md={4}><TextBoxComponent placeholder={t("surname")} disabled value={myData.surname} floatLabelType="Auto" /></Grid>
                <Grid item xs={12} md={4}><TextBoxComponent placeholder={t("authRoleId")} disabled value={myData.userRole} floatLabelType="Auto" /></Grid>
                <Grid item xs={12} md={4}><TextBoxComponent id="email" type="email" placeholder={t("email")} value={myData.email} floatLabelType="Auto" /></Grid>
                <Grid item xs={12} md={4}><TextBoxComponent id="home" placeholder={t("homeNr")} value={myData.home} floatLabelType="Auto" /></Grid>
                <Grid item xs={12} md={4}><TextBoxComponent id="mobile" placeholder={t("mobile")} value={myData.mobile} floatLabelType="Auto" /></Grid>
                <Grid item xs={12}>
                  <Stack direction="row" justifyContent="flex-end">
                    <Button variant="contained" color="primary" onClick={() => this.confirmSave()}>{t("btnSave")}</Button>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>

            <Paper elevation={3} sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>{t("lblChangePwd")} *</Typography>
              <Divider sx={{ mb: 2 }} />
			  <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type={showPwd.old ? "text" : "password"}
                    label={t("old")}
                    value={oldPwd}
                    onChange={(e) => this.onPwdInputChange("oldPwd", e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => this.togglePasswordVisibility("old")}>{showPwd.old ? <VisibilityOff /> : <Visibility />}</IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type={showPwd.new ? "text" : "password"}
                    label={t("new")}
                    value={newPwd}
                    onChange={(e) => this.onPwdInputChange("newPwd", e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => this.togglePasswordVisibility("new")}>{showPwd.new ? <VisibilityOff /> : <Visibility />}</IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    type={showPwd.confirm ? "text" : "password"}
                    label={t("confirmNew")}
                    value={confirmPwd}
                    onChange={(e) => this.onPwdInputChange("confirmPwd", e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => this.togglePasswordVisibility("confirm")}>{showPwd.confirm ? <VisibilityOff /> : <Visibility />}</IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </Grid>
                <Grid item xs={12}><Typography variant="caption">{t("lblPwdCriteria")}</Typography></Grid>
                <Grid item xs={12}>
                  <Stack direction="row" justifyContent="flex-end">
                    <Button
                      id="resetBtn"
                      variant="contained"
                      color="primary"
                      onClick={() => this.openDialog()}
                      disabled={!isPwdValid}
                    >
                      {t("btnChangePwd")}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>

            <DialogComponent
              id="confirmDialog"
              isModal={true}
              header={t("lblChangePwd")}
              visible={showConfirmDialog}
              showCloseIcon={true}
              width="400px"
              height="150px"
              content={t("confirmQuestion")}
              ref={(dialog) => (this.confirmDialogInstance = dialog)}
              close={() => this.setState({ showConfirmDialog: false })}
              target="#target"
              buttons={this.confirmButton}
            />
          </Box>
        )}
        <ToastComponent
          ref={(toast) => (this.toastObj = toast)}
          id="toast_default"
          position={this.position}
          title={toastInfo.title}
          content={toastInfo.content}
          cssClass={toastInfo.cssClass}
          icon={toastInfo.icon}
        />
      </Box>
    );
  }
}

export default withTranslation()(Profile);
